<template>
    <div class="vh-animate vh-animate-fade-in">
        <Bar
            :data="{
                labels: dataLabels,
                datasets: [
                    {
                        backgroundColor: backgroundColor,
                        data: dataValues
                    }
                ]
            }"
            
            :options="{
                plugins:
                {
                    legend:
                    {
                        display: isLegendVisible,
                        position: 'bottom',
                    },
                    title:
                    {
                        display: isTitleVisible,
                        text: title
                    },
                },
                onClick: this.handle,
            }"
            
            :style="style"
            />
    </div>
    
    
</template>
<script>
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
} from 'chart.js'
import { Bar } from 'vue-chartjs'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export default
{
    components:
    {
        Bar
    },

    props:
    {
        title:
        {
            type: String,
            default: () => ''
        },
        dataLabels:
        {
            type: Array,
            default: () => {
                return [];
            }
        },
        dataValues:
        {
            type: Array,
            default: () => {
                return [];
            }
        },

        backgroundColor:
        {
            type: Array,
            default: () => [
                '#228CDB',
                '#26CC6E',
                '#FF9E0F',
                '#00C5CE',
            ]
        },
        borderWidth:
        {
            type: Number,
            default: 1,
        },

        isLegendVisible:
        {
            type: Boolean,
            default: true,
        },

        isTitleVisible:
        {
            type: Boolean,
            default: false,
        },

        usePercentage:
        {
            type: Boolean,
            default: false,
        },

        style:
        {
            type: Object,
            default: () => {}
        },

        onClick:
        {
            type: Function,
            default: null,
        }
    },

    methods:
    {
        handle({ chart }, array)
        {
            console.log(chart, array);
            // this.$emit('onChartEmit', {
            //     index: array[0].index,
            //     value: chart.tooltip._data.datasets[0].data[array[0]._index],
            // });
        },
    },
};
</script>
